// extracted by mini-css-extract-plugin
export default {"card":"NewEmployee_card__the40"};